/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win6_TInputs */

const en_wc_vs_win6_t = /** @type {(inputs: Wc_Vs_Win6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made for automation`)
};

/**
* | output |
* | --- |
* | "Made for automation" |
*
* @param {Wc_Vs_Win6_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win6_t = /** @type {((inputs?: Wc_Vs_Win6_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win6_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win6_t(inputs)
});
export { wc_vs_win6_t as "wc.vs.win6.t" }